import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../login/login";
import "./demo.css";
import MainRoute from '../official_web/main_route';
import { Helmet } from 'react-helmet';

import { Mainlayout } from '../ui/ot';
import NavBarBackend from './../../theme/layout_backend2'
import RouteOrganizationStructure from './../../components/organization_structure/MainRoute';
import MainRouteLibrary from './../../components/Library/MainRoute'
import MainRouteLibraryFront from './../../components/Library/MainRouteFront'
import LibraryLayout from '../Library/views/Layout'
import AppMainRoute from "../../pages/app/MainRoute"
import LatestNewsPage from '../official_web/components/LatestNewsPage'
import axios from "axios";
import LineLogin from '../login/LineLogin';
import Library from '../koha/views/library';
import LibraryOpenHourManagement from '../project_library/library_open_hour_management';
import HolidayManagement from '../reservation_registration_and_space_management/views/holiday_management'
import HolidayDetailManagement from '../reservation_registration_and_space_management/views/holiday_detail_management'
import PreviewPortal from '../official_web/preview_portal'
const RouteOfficeWeb = ({
    admin = true
}) => {
    const mobile = localStorage?.getItem('mobile') || 'true';
    return (<>
        <Helmet>
            {mobile === 'true' &&
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            }
        </Helmet>
        <BrowserRouter>
            <Routes>
                <Route path={'login'}>
                    <Route index element={<Login logo="AI" />} />
                </Route>
                <Route path={'line_login'}>
                    <Route index element={<LineLogin logo="AI" />} />
                </Route>
                <Route path={'user_login'}>
                    <Route index element={<Login logo="AI" defaultLogoInURL={'/library/personal_info_query'} />} />
                </Route>
                <Route path={'/LatestNewsPage'} element={<LatestNewsPage />} />

                <Route index element={<Navigate to={admin ? "/library/backstage" : "/officialweb/frontend"} />} />
                {/* <Route index element={<Navigate to="/library/backstage" />} /> */}

                {/* <Route path={'/officialweb/*'} element={<MainRoute admin={true} prefixTitle = '形象網站'/>} /> */}
                {/* <Route path={'/officialweb/*'} element={<MainRoute admin={admin} prefixTitle='空軍航空學校' />} /> */}
                <Route path={'/officialweb/*'} element={<MainRoute admin={admin} prefixTitle='iRead圖書自動化系統' />} />
                {/* true是要登入的 false是只會剩下形象的前台 */}
                {/* 入口網新版型 preview（隱藏 route，不掛選單）；舊 /officialweb/frontend 不動 */}
                <Route path={'/officialweb_preview/*'} element={<PreviewPortal />} />
                {/* </Route> */}
                <Route path={'/'} element={<LibraryLayout />}>
                </Route>
                <Route path={'library/*'} element={<MainRouteLibrary propsPath='/library' admin={admin} defaultAdminRoute='/library/backstage' defaultNotAdminRoute='/library/online_public_catalog_query_construction' />} >
                </Route>
                



                {/* <Route path={'library/*'} element={<MainRouteLibrary propsPath='/library' admin={admin} defaultAdminRoute='/library/backstage' defaultNotAdminRoute='/library/online_public_catalog_query_construction' />} >
                </Route> */}
                {/* <Route path={'library'} >
                    {admin && (<Route path={""} element={<JWT />}>
                        <Route path={''} element={<NavBarBackend prefixTitle={'圖書自動化系統'} not_sider menuData={menuData} selfSettingButtonMode={true} selfSettingRoute='/library/organization_structure/home' />}>
                            <Route path="" element={<Mainlayout />}>
                                <Route path={'*'} element={<MainRouteLibrary 
                                // menuData={menuData}
                                 />}>
                                </Route>
                                <Route path={'organization_structure/*'} element={<RouteOrganizationStructure />}>
                                </Route>
                            </Route>
                        </Route>
                    </Route>)}
                    <Route path="" element={<LibraryLayout />}>
                        <Route path={'online_public_catalog_query_construction/*'}
                            element={<MainRouteLibraryFront
                                propsPath='/library'
                            />}
                        >
                        </Route>
                    </Route>
                </Route> */}
            </Routes>
        </BrowserRouter>
    </>);
}
export default RouteOfficeWeb;

const menuData = [
    {
        key: '/officialweb/admin',
        label: '圖書入口網設定'
    }, {
        key: '/library/online_public_catalog_query_construction',
        label: '圖書自動化系統前台首頁'
    },
    {
        label: '系統後台基本資料設定',
        children: [
            {
                key: '/library/backstage/backend_basic_settings/item_types_management',
                label: '館藏分類管理',
            },
            {
                key: '/library/backstage/backend_basic_settings/authorized_category_management',
                label: '授權值管理',
            },
            {
                key: '/library/backstage/backend_basic_settings/library',
                label: '分館管理',
            },
        ]
    },
    {
        label: '編目模組',
        children: [
            {
                key: '/library/backstage/SearchZ3950',
                label: 'Z39.50搜尋',
            },
            {
                key: '/library/backstage/framework_management',
                label: 'MARC 框架管理'
            },
            {
                key: '/library/backstage/tag_structure_management',
                label: 'MARC 書目架構欄位管理'
            },
            {
                key: '/library/backstage/subfield_structure_management',
                label: '欄位分欄管理'
            },
            {
                key: '/library/backstage/AddMARC',
                label: '新增書目',
            },
            {
                key: '/library/backstage/StageMARCRecord',
                label: '匯入書目',
            },
            {
                key: '/library/backstage/ManageMARCRecord',
                label: '管理書目',
            },
            {
                key: '/library/backstage/LabelPrint',
                label: '標籤製作',
            },
            // {
            //     key: '/library/backstage/authority',
            //     label: '權威控制管理'
            // },
            // {
            //     key: '/library/backstage/serial_frequency_management',
            //     label: '期刊頻率管理'
            // },
            // {
            //     key: '/library/backstage/serial_code_management',
            //     label: '期刊編碼管理'
            // },
            // {
            //     key: '/library/backstage/serials_management',
            //     label: '期刊訂閱管理'
            // },



        ],
    },
    {
        label: '期刊模組',
        children: [
            {
                key: '/library/backstage/serial_frequency_management',
                label: '期刊頻率管理'
            },
            {
                key: '/library/backstage/serial_code_management',
                label: '期刊編碼管理'
            },
            {
                key: '/library/backstage/serials_management',
                label: '期刊訂閱管理'
            },
        ],
    },
    {
        label: '流通模組',
        children: [
            // {
            //     key: '/library/backstage/Circulation/CheckOut',
            //     label: '借書及續借',
            // },
            {
                key: '/library/backstage/Patrons/CheckOutHistory',
                label: '借閱歷史記錄',
            },
            {
                key: '/library/backstage/Circulation/CheckOutSetting',
                label: '館員借閱',
            },
            {
                key: '/library/backstage/Circulation/RenewSetting',
                label: '館員續借',
            },
            {
                key: '/library/backstage/Circulation/HoldSetting',
                // key: '/library/backstage/Circulation/HoldSetting/1',
                label: '預約設定',
            },
            {
                key: '/library/backstage/library_transfer_limit_management',
                label: '分館轉移限制管理'
            },
            {
                key: '/library/backstage/library_transfer_management',
                label: '分館轉移管理'
            },
            {
                key: '/library/backstage/Circulation/Rules',
                label: '流通規則設定',
            },
            // {
            //     // key: '/library/backstage/Circulation/HoldSetting',
            //     key: '/library/backstage/Circulation/HoldPriority',
            //     label: '預約順序調整',
            // },
            // {
            //     key: '/library/backstage/Circulation/Rules',
            //     label: '流通規則設定',
            // },
        ],
    },
    // {
    //     key: '/library/backstage',
    //     label: '圖書自動化系統後台首頁'
    // },
    // {
    //     key: '/ReaderService',
    //     label: '個人書房'
    // },
    {
        label: '使用者管理',
        children: [
            {
                key: '/library/backstage/department_patron_categories',
                label: '系統角色（讀者類型）設定',
            },
            {
                key: '/library/backstage/role',
                label: '角色身份管理',
            },
            {
                // key: '/organization_structure/staff',
                key: '/library/backstage/staff_patron',
                label: '人員資料管理',
            },
        ],
    },
    {
        label: '系統前台基本資料設定',
        children: [
            {
                key: '/library/backstage/frontend_basic_settings/question_and_answer',
                label: '常見問題管理'
            },
            {
                key: '/library/backstage/frontend_basic_settings/news_type',
                label: '消息分類管理'
            },
            {
                key: '/library/backstage/frontend_basic_settings/news',
                label: '最新消息管理'
            },
        ]
    },
    //站不開放
    // {
    //     label: '期刊模組',
    //     children: [
    //         {
    //             key: '/library/backstage/serials_management',
    //             label: '連續性出版品設定',
    //         },
    //         {
    //             key: '/library/backstage/serial_frequency_management',
    //             label: '刊期管理',
    //         },
    //         {
    //             key: '/library/backstage/serial_code_management',
    //             label: '期刊編碼管理',
    //         },
    //     ]
    // },


]
const JWT = () => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        function (error) {
            const access_token_url = "/access_token";
            const config = error.config;
            if (error.response?.status === 401 && config.url === access_token_url) {
                window.location.href = "/login";
                return Promise.reject(error);
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true;
                const refreshToken = localStorage.getItem("refresh_token");
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken,
                    })
                    .then((res) => {
                        if (res?.status === 201) {
                            localStorage.setItem("access_token", res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            };
                            return axios(config);
                        }
                    });
            }
            return Promise.reject(error);
        }
    );
    return <Outlet />;
};